import { AddressData } from './address-data';
import { CategoryData } from './category-data';
import { FilterData } from './filter-data';
import { MediaData } from './media-data';
import { PlatformData } from './platform-data';
import { PriceData } from './price-data';

export class CreateOfferData {
    platformData: PlatformData = new PlatformData();
    categoryData: CategoryData = new CategoryData();
    filterData: FilterData = new FilterData();
    priceData: PriceData = new PriceData();
    addressData: AddressData = new AddressData();
    mediaData: MediaData = new MediaData();

    static createEmpty(): CreateOfferData {
        return new CreateOfferData();
    }
}

export type CreateOfferTab = {
    text: string;
    icon?: string;
    color?: string;
    last?: boolean;
    slug: TabSlug;
    disabled: boolean;
};

export type TabSlug = 'platform' | 'category' | 'filters' | 'details' | 'price' | 'location' | 'photos' | 'delivery' | 'boost';
